import { useField } from 'react-final-form';

import { useControlsGroupState } from '@cast/shared-rff-ui';
import { toNumOrUndefined } from '@cast/utils';

type ResourceSettings = {
  percentile?: number;
  overhead?: number;
};

const toFraction = (value: unknown): number | undefined => {
  const parsed = toNumOrUndefined(value);
  return parsed === undefined ? undefined : parsed / 100;
};

/**
 * Reads the current overhead + recommendation-percentile values from the form,
 * honoring the active `namePrefix` so the same settings container works both on
 * the scaling-policy page (`vpa.*`) and on the workload details page.
 *
 * Field values are stored as percentages (0..100) so we convert them to
 * fractions here.
 */
export const useSimulationSettings = (): {
  cpu: ResourceSettings;
  memory: ResourceSettings;
} => {
  const { namePrefix } = useControlsGroupState();

  const cpuPercentile = useField(`${namePrefix}.recommendationPercentile.cpu`)
    .input.value;
  const memoryPercentile = useField(
    `${namePrefix}.recommendationPercentile.memory`
  ).input.value;
  const cpuOverhead = useField(`${namePrefix}.overhead.cpu`).input.value;
  const memoryOverhead = useField(`${namePrefix}.overhead.memory`).input.value;

  return {
    cpu: {
      percentile: toFraction(cpuPercentile),
      overhead: toFraction(cpuOverhead),
    },
    memory: {
      percentile: toFraction(memoryPercentile),
      overhead: toFraction(memoryOverhead),
    },
  };
};
